export default "__VITE_ASSET__DeAKU8uO__"